export enum LegTypeEnum{
    Inbound = 'Inbound',
    InboundEmpty = 'InboundEmpty',
    Outbound = 'Outbound',
    OutboundEmpty = 'OutboundEmpty',
    Transfer = 'Transfer',
    OutboundHub = 'OutboundHub'
}